import { ApiRequestError } from "@/lib/auth-api";
import type { GeneratedCase, PageTestSource, TestRun } from "@/lib/qa-types";

export function authErrorMessage(error: unknown): string {
    if (!(error instanceof ApiRequestError)) return "登录失败，请稍后重试";
    if (error.errorCode === "INVALID_CREDENTIALS") return "用户名或密码错误";
    if (error.errorCode === "VALIDATION_ERROR") return "用户名格式或密码长度不符合要求";
    if (error.errorCode === "SESSION_INVALID" || error.errorCode === "AUTH_REQUIRED") return "登录状态已失效，请重新登录";
    return error.message;
}

export function fallbackPipelineRun(source: PageTestSource, generated: GeneratedCase[], status: TestRun["status"]): TestRun {
    return {
        run_id: `RUN-LOCAL-${Date.now()}`,
        status,
        environment: "uat",
        priority: "P0",
        case_ids: generated.map((item) => item.case_id),
        source_url: source.target_url,
        requirement: source.requirement,
        agent_id: "agent-sh-01",
        lease_expires_at: new Date(Date.now() + 5 * 60_000).toISOString(),
        events: [],
        healing: null,
        artifacts: [],
        jira_key: null,
    };
}
